import { useState } from "react";

function LastChanges({ lastCanvis, setNLastCanvis, bundles, displayName }) {

    // Extract bundle name from filename (e.g. "0ea902c740.e0yzmnpr9hl.canvis" -> bundle name)
    const filenameToBundle = (filename) => {
        const bundleId = filename?.split('.')?.[0] ?? '';
        return bundles.find(bundle => bundle.id === bundleId)?.nom ?? bundleId;
    }

    // Build Aleta editor URL from eventId and filename
    // e.g. eventId="233783", filename="0ea902c740.e0yzmnpr9hl.canvis" -> "/233783/0ea902c740/e0yzmnpr9hl/edit"
    const changeToAletaURL = (change) => {
        if (!change.eventId || !change.filename) return '';
        // Remove .canvis extension and replace dots with slashes
        const withoutExt = change.filename.replace('.canvis', '');
        const fileToSlashes = withoutExt.replace(/\./g, '/');
        return `/${change.eventId}/${fileToSlashes}/edit`;
    };

    const packChanges = (changes) => {
        const packedChanges = [];
        let i = 0;
      
        while (i < changes.length) {
          const change = changes[i];
          let count = 1;
          let individualChanges = [change];
      
          // Look ahead to see if the next change is by the same author and same file
          while (i + count < changes.length &&
                 changes[i + count].author === change.author &&
                 changes[i + count].eventId === change.eventId &&
                 changes[i + count].filename === change.filename) {
            individualChanges.push(changes[i + count]);
            count++;
          }
      
          // Push the packed change to the array
          packedChanges.push({ ...change, count: count, individualChanges: individualChanges });
      
          // Skip over the changes that were packed
          i += count;
        }
      
        return packedChanges;
    };      

    const [selectedChange, setSelectedChange] = useState(null);

    return (
        <div
            style={{
                paddingBottom: 50,
            }}
        >
            <h2>Últims canvis</h2>
            <div style={{ listStyleType: 'none', padding: 0 }}>
            {
                packChanges(lastCanvis)
                    .flatMap((change, index) => [
                        <div onClick={() => setSelectedChange(prev => JSON.stringify(prev) === JSON.stringify(change) ? null : change)} key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '5px', padding: '10px', backgroundColor: '#f9f9f9' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '10px' }}>{displayName(change.author)}</span>
                            <span style={{ color: '#888' }}>{new Date(change.timestamp).toLocaleString()}</span>
                            <a target="_blank" href={changeToAletaURL(change)} style={{ marginLeft: '10px', color: '#007bff' }}>{filenameToBundle(change.filename)}</a>
                            <a style={{ marginLeft: '10px' }}>{change.count} canvis</a>
                        </div>,
                        JSON.stringify(selectedChange) === JSON.stringify(change) && change.individualChanges.map((individualChange, i) => (
                            <div key={i} style={{ marginLeft: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', backgroundColor: '#f9f9ef9', borderRadius: '5px', marginBottom: '10px' }}>
                                { individualChange.casteller !== '_EMPTY_' && <span>Ha posat {displayName(individualChange.casteller)}</span> }
                                { individualChange.casteller === '_EMPTY_' && <span>Ha buidat una caixa</span> }
                                <span style={{ color: '#888', marginRight: '10px' }}>{new Date(individualChange.timestamp).toLocaleString()}</span>
                            </div>
                        ))
                    ])
            }
            </div>
            <button onClick={() => setNLastCanvis(prev => prev + 100)} style={{ marginTop: '20px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 20px', cursor: 'pointer' }}>
                Mostra'n més +
            </button>
        </div>
    )
}

export default LastChanges;